import { ChangePaymentMethodButton } from '@app/common/src/components/PlanPurchaseExperience/components/ChangePaymentMethodButton'
import { CreatePaymentMethod } from '@app/common/src/components/PlanPurchaseExperience/components/CreatePaymentMethod'
import { FC } from 'react'
import { PaymentMethod } from '@stripe/stripe-js'
import { PaymentMethodAddressField } from '@app/common/src/components/PlanPurchaseExperience/components/PaymentMethodAddressField'
import { PaymentMethodDisplay } from '@app/common/src/components/PlanPurchaseExperience/components/PaymentMethodDisplay'
import { Stack, Typography } from '@dtx-company/design-system/src'
import { displayPaymentMethodAddressFields } from '@app/common/src/components/PlanPurchaseExperience/constants'
import useTranslation from 'next-translate/useTranslation'

export interface CreditCardFieldProps {
  existingPaymentMethod?: PaymentMethod
  showExistingCreditCard: boolean
  paymentMethodType?: string
  onShowExistingCreditCardChange: (value: boolean) => void
  setPaymentIsCompleted: (value: boolean) => void
  setPaymentType: (value: string) => void
}

export const PaymentMethodPlanPurchaseFormField: FC<CreditCardFieldProps> = ({
  existingPaymentMethod,
  showExistingCreditCard,
  onShowExistingCreditCardChange,
  setPaymentIsCompleted,
  setPaymentType,
  paymentMethodType
}) => {
  const { t } = useTranslation('payment-messages')
  return (
    <>
      {showExistingCreditCard && existingPaymentMethod && (
        <Stack direction={'row'} justifyContent={'space-between'} sx={{ width: '100%' }}>
          <PaymentMethodDisplay paymentMethod={existingPaymentMethod} mode={'default'} />
          <ChangePaymentMethodButton
            onShowExistingCreditCardChange={onShowExistingCreditCardChange}
          />
        </Stack>
      )}
      {!showExistingCreditCard && (
        <Stack gap={4}>
          <CreatePaymentMethod
            onChange={event => {
              setPaymentIsCompleted(event.complete)
              setPaymentType(event.value.type)
            }}
          />
          {paymentMethodType && displayPaymentMethodAddressFields.includes(paymentMethodType) && (
            <>
              <Typography variant={'subtitleSmall'}>{t('paymentAddressTitle')}</Typography>
              <PaymentMethodAddressField heapEventName={'PaymentMethodPlanPurchaseFormField'} />
            </>
          )}
        </Stack>
      )}
    </>
  )
}
